import { useContext } from "react";
import { Stack, Typography, Avatar } from "@mui/material";
import moment from "moment";
//Srcs
import "./dashboardstyle.scss";
import LoadingPage from "../../Utils/LoadingPage";
import "../../Style/pagestyle.scss";
import EmptyData from "../Include/EmptyData/EmptyData";
import { AuthContext } from "../../Context/AuthContext";
import useGetTeacherBirthdayForDashboard from "../../Hooks/useGetTeacherBirthdayForDashboard";

export default function TeacherBirthday() {
  const { t } = useContext(AuthContext);

  const { tableData, loading } = useGetTeacherBirthdayForDashboard();

  // console.log("tableData::", tableData);

  return (
    <div className="chart-container">
      <Stack
        direction="column"
        justifyContent="space-between"
        sx={{ height: "100%" }}
      >
        <Stack direction="column" spacing={2}>
          <Stack direction="row" justifyContent={"space-between"}>
            <Typography className="chart-title">
              {t("table_teacher_birthday")}
            </Typography>
          </Stack>

          {loading ? (
            <Stack
              direction="column"
              justifyContent="center"
              sx={{ height: "300px" }}
            >
              <LoadingPage />
            </Stack>
          ) : tableData?.length === 0 ? (
            <Stack
              direction="column"
              justifyContent="center"
              sx={{ height: "300px" }}
            >
              <EmptyData />
            </Stack>
          ) : (
            <Stack direction="column" spacing={1}>
              {tableData?.map((row, index) => {
                return (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    key={index}
                    className="student-card"
                  >
                    <Stack direction="row" spacing={1.4}>
                      <Stack direction="column" justifyContent="center">
                        <Avatar
                          sx={{ width: 40, height: 40 }}
                          alt={row?.userName}
                          src={row?.profile}
                        />
                      </Stack>
                      <Stack direction="column" justifyContent="center">
                        <Typography className="student-name">
                          {row?.familyName + " " + row?.userName}
                        </Typography>
                      </Stack>
                    </Stack>

                    <Stack direction="column" justifyContent="center">
                      <Typography className="class-name">
                        {row?.gender}
                      </Typography>
                    </Stack>

                    <Stack direction="column" justifyContent="center">
                      <Typography className="student-status">
                        {moment(row?.dob).format("DD-MMM-YYYY")}
                      </Typography>
                    </Stack>
                  </Stack>
                );
              })}
            </Stack>
          )}
        </Stack>
      </Stack>
    </div>
  );
}
